import { render, staticRenderFns } from "./About.vue?vue&type=template&id=53dc5c62&scoped=true"
import script from "./About.js?vue&type=script&lang=js&external"
export * from "./About.js?vue&type=script&lang=js&external"
import style0 from "./About.scss?vue&type=style&index=0&id=53dc5c62&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dc5c62",
  null
  
)

export default component.exports